import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";

Vue.config.productionTip = false;

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";
Vue.component("v-icon", Icon);

import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);

import VueGtag from "vue-gtag";
Vue.use(
  VueGtag,
  {
    config: { id: "UA-90740854-1" },
    pageTrackerTemplate(to) {
      return {
        page_path: to.fullPath,
        page_title: "Page race - " + to.name,
      };
    },
  },
  router
);

import { ColorPicker, ColorPanel } from "one-colorpicker";
Vue.use(ColorPanel);
Vue.use(ColorPicker);

import VueCookies from "vue-cookies";
Vue.use(VueCookies, { expire: "7d" });

import VueMeta from 'vue-meta'

Vue.use(VueMeta)

new Vue({
  router,
  store,
  i18n,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
